import React from "react";

import { env } from "~/env";
import { icons } from "~/ui";

export const NoProviderData = ({ selectedDate }: { selectedDate: Date }) => {
  const currentDate = new Date();

  const maxAllowedDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + Number(env.VITE_APPOINTMENT_SLOT_MAX_MONTHS),
    1,
  );

  const isMaxMonth =
    selectedDate.getFullYear() === maxAllowedDate.getFullYear() &&
    selectedDate.getMonth() === maxAllowedDate.getMonth();

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="flex flex-row items-center gap-2">
        <icons.outline.CalendarIcon
          className="-mt-1 size-5 font-medium text-gray-700"
          strokeWidth={2}
        />
        <h2 className="text-lg font-medium text-gray-700">
          No slots available
        </h2>
      </div>
      {isMaxMonth ? (
        <p className="w-2/3 text-center text-sm text-gray-500 md:w-full">
          There are no clinicians that match your search. Please call us at{" "}
          <a href="tel:+16467606669" className="text-blue-600 underline">
            (646) 760-6669
          </a>{" "}
          and we’ll help you book your appointment.
        </p>
      ) : (
        <p className="w-2/3 text-center text-sm text-gray-500 md:w-full">
          There are no slots available. Call us at{" "}
          <a href="tel:+16467606669" className="text-blue-600 underline">
            (646) 760-6669
          </a>{" "}
          and we’ll help you book your appointment.
        </p>
      )}
    </div>
  );
};
